import { PayMethod } from "../types/types";

export const getPG = (payMethod: PayMethod) => {
    switch (payMethod) {
        case 'KAKAO':
            return 'kakaopay.' + process.env.REACT_APP_IAMPORT_KAKAO_CID;
        case 'NAVER':
            return 'naverpay.' + process.env.REACT_APP_IAMPORT_NAVER_CID;
        default:
            return 'kcp.' + process.env.REACT_APP_IAMPORT_KCP_CID;
    }
}